
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class ModalVideoPlayer extends Vue {
  @Prop() readonly youtubeUrlList!: any;

  private showModal = true;
  private iframe = "";

  created() {
    if (this.youtubeUrlList && this.youtubeUrlList.length > 0) {
      const youtubeItem = this.youtubeUrlList.find((x: any) => x.isShow);
      if (youtubeItem) {
        this.SetIframe(youtubeItem.url);
      } else {
        this.youtubeUrlList[0].isShow = true;
        this.SetIframe(this.youtubeUrlList[0].url);
      }
    }
  }

  @Watch("showModal")
  showModalChanged(newVal: boolean) {
    if (!newVal) {
      this.HideModal();
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
  public ShowVideo(youtubeIndexItem: any) {
    this.youtubeUrlList.forEach((youtube: any, index: number) => {
      if (index == youtubeIndexItem) {
        this.SetIframe(youtube.url);
        youtube.isShow = true;
      } else {
        youtube.isShow = false;
      }
    });
  }

  public SetIframe(url: string) {
    this.iframe = `<iframe width="700" height="400" src="${url}" title="YouTube video player" frameborder="0"  clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  }
}
